import {
  whiteColor,
  hexToRgb,
} from "assets/jss/material-dashboard-pro-react.js";

const cardBodyStyle = {
  cardBody: {
    padding: "0.9375rem 20px",
    flex: "1 1 auto",
    WebkitBoxFlex: "1",
    position: "relative",
  
    "@media (max-width: 1400px)": {
      padding: "0.875rem 18px",
    },
  
    "@media (max-width: 1200px)": {
      padding: "0.75rem 16px",
    },
  
    "@media (max-width: 960px)": {
      padding: "0.75rem 14px",
    },
  
    "@media (max-width: 600px)": {
      padding: "0.625rem 12px",
    },
  },
  cardBodyBackground: {
    position: "relative",
    zIndex: "2",
    minHeight: "280px",
    paddingTop: "40px",
    paddingBottom: "40px",
    maxWidth: "440px",
    margin: "0 auto",
  
    "@media (max-width: 1200px)": {
      minHeight: "240px",
      paddingTop: "32px",
      paddingBottom: "32px",
    },
  
    "@media (max-width: 960px)": {
      minHeight: "200px",
      paddingTop: "24px",
      paddingBottom: "24px",
      maxWidth: "100%",
    },
  
    "@media (max-width: 600px)": {
      minHeight: "auto",
      paddingTop: "20px",
      paddingBottom: "20px",
    },
  },
  cardBodyPlain: {
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  cardBodyFormHorizontal: {
    paddingLeft: "15px",
    paddingRight: "15px",
  
    "@media (max-width: 960px)": {
      paddingLeft: "10px",
      paddingRight: "10px",
    },
  
    "@media (max-width: 600px)": {
      paddingLeft: "6px",
      paddingRight: "6px",
    },
  
    "& form": {
      margin: "0",
    },
  },
  cardPricing: {
    padding: "15px!important",
    margin: "0px!important",
  
    "@media (max-width: 960px)": {
      padding: "12px!important",
    },
  
    "@media (max-width: 600px)": {
      padding: "10px!important",
    },
  },
  cardSignup: {
    padding: "0px 30px",
  
    "@media (max-width: 1200px)": {
      padding: "0px 24px",
    },
  
    "@media (max-width: 960px)": {
      padding: "0px 18px",
    },
  
    "@media (max-width: 600px)": {
      padding: "0px 12px",
    },
  },
  cardBodyColor: {
    borderRadius: "6px",
    "& h1,& h2,& h3": {
      "& small": {
        color: "rgba(" + hexToRgb(whiteColor) + ", 0.8)",
      },
    },
  },
  cardBodyProfile: {
    marginTop: "15px",
  },
  cardBodyCalendar: {
    padding: "0px !important",
  },
};

export default cardBodyStyle;
